var _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgAnalytics = function SvgAnalytics(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.449 0c.35 0 .64.261.686.6l.006.093v17.711c0 .351-.26.64-.599.687l-.094.006h-4.427l-.023-.002-.022.002H.693a.693.693 0 0 1-.687-.599L0 18.404v-4.427c0-.351.26-.64.599-.687l.094-.006h3.734l.001-3.735c0-.316.211-.582.5-.666l.099-.02.094-.007h3.733l.001-3.735c0-.316.211-.582.5-.666l.099-.02.094-.007h3.779l.001-3.735c0-.316.21-.582.5-.666l.099-.02L14.02 0h4.428ZM4.427 14.668H1.385v3.042h3.042v-3.042Zm4.428-4.428H5.813v7.47h3.042v-7.47Zm4.427-4.427H10.24V17.71h3.042V5.813Zm4.473-4.427h-3.042V17.71h3.042V1.386Z",
    fill: "#264D6D",
    fillRule: "nonzero"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgAnalytics, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/analytics.b5f3011a.svg";
export { ForwardRef as ReactComponent };